import { render, staticRenderFns } from "./DataItemInfoDateItem.vue?vue&type=template&id=72fe9f96&"
import script from "./DataItemInfoDateItem.vue?vue&type=script&lang=js&"
export * from "./DataItemInfoDateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports